


// to fetch cat from firestore only

// services/categoryService.js
import { db } from './../../firebase/firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';

export const fetchCategories = async () => {
  const categoriesCollection = collection(db, 'Categories');
  const categoriesSnapshot = await getDocs(categoriesCollection);
  const categoriesList = categoriesSnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
  return categoriesList;
};

